import { render, staticRenderFns } from "./CategoryAddDialog.vue?vue&type=template&id=1dd5d021&scoped=true"
import script from "./CategoryAddDialog.vue?vue&type=script&lang=js"
export * from "./CategoryAddDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryAddDialog.vue?vue&type=style&index=0&id=1dd5d021&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5d021",
  null
  
)

export default component.exports